import { render } from "./Longshot.vue?vue&type=template&id=f0ffbc3e"
import script from "./Longshot.vue?vue&type=script&lang=js"
export * from "./Longshot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__